import styled from 'styled-components';

export const Wrapper = styled.div<{ $hasValue: boolean }>`
  display: flex;
  align-items: center;
  width: 150px;
  position: relative;
  border-radius: 4px;
  border: 1px solid
    ${({ theme, $hasValue }) => ($hasValue ? theme.colors.green7 : theme.colors.black4)} !important;
  background-color: ${({ theme, $hasValue }) =>
    $hasValue ? theme.colors.green2 : 'transparent'} !important;

  &:hover {
    border-color: ${({ theme }) => theme.colors.black4} !important;
    background-color: ${({ theme }) => theme.colors.green1} !important;
  }

  &:focus {
    border-color: ${({ theme }) => theme.colors.green7} !important;
    background-color: ${({ theme }) => theme.colors.green2} !important;
  }

  &:active {
    border-color: ${({ theme }) => theme.colors.green7} !important;
    background-color: ${({ theme }) => theme.colors.green2} !important;
  }
`;
